import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import Animated, { useSharedValue, useAnimatedStyle, withTiming } from 'react-native-reanimated';
import TextLato from '../text/text-lato/TextLato';
import { styles, NUMBER_HEIGHT, ANIMATION_DURATION, TIMING_CONFIG } from './ProductCountBadge.styles';

interface ProductCountBadgeProps {
  currentIndex: number;
  totalCount: number;
  label: string;
  testID?: string;
}

const AnimatedNumber = ({ value, style }: { value: number; style?: any }) => {
  const [displayValue, setDisplayValue] = useState(value);
  const [nextValue, setNextValue] = useState(value);
  const translateY = useSharedValue(0);

  useEffect(() => {
    if (value <= 0 && value === displayValue) return;

    setNextValue(value);
    translateY.value = 0;
    translateY.value = withTiming(-NUMBER_HEIGHT, TIMING_CONFIG, finished => {
      if (finished) {
        // After animation completes, update display value and reset position
      }
    });

    const timeout = setTimeout(() => {
      setDisplayValue(value);
      translateY.value = 0;
    }, ANIMATION_DURATION);

    return () => clearTimeout(timeout);
  }, [value]);

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ translateY: translateY.value }],
  }));

  return (
    <View style={styles.numberContainer}>
      <Animated.View style={animatedStyle}>
        <TextLato style={style ? style : styles.text}>{displayValue}</TextLato>
        <TextLato style={style ? style : styles.text}>{nextValue}</TextLato>
      </Animated.View>
    </View>
  );
};

const ProductCountBadge = ({ currentIndex, totalCount, label, testID }: ProductCountBadgeProps) => {
  return (
    <View style={styles.container} testID={testID}>
      <AnimatedNumber value={currentIndex} />
      <TextLato style={styles.separator}> | </TextLato>
      <AnimatedNumber value={totalCount} style={styles.textRegular} />
      <TextLato style={styles.textRegular}> {label}</TextLato>
    </View>
  );
};

export default ProductCountBadge;
